import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { Divider, Table, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import 'moment/locale/es'

import NewSaleLogModal from '../../SaleLogs/partials/NewSaleLogModal'
import CustomerInvoicesDrawer from '../../Customers/partials/CustomerInvoicesDrawer'
import Pagination from '../../../components/Pagination'
import CallButton from '../../../components/CallButton'
import WhatsappButton from '../../../components/WhatsappButton'

export default function InvoicesTable({ invoices, reload, pagination, setPagination }) {
	const [invoicesDrawer, setInvoicesDrawer] = useState(null)
	const [newSaleLog, setNewSaleLog] = useState(null)
	
	const columns = [
		{
			title: 'Fecha Factura',
			width: '120px',
			dataIndex: 'sold_at',
			render: t => moment(t).format('DD-MM-YYYY')
		},
		{
			title: 'Referencia',
			dataIndex: 'reference',
			render: t => t.replace(/(\w| )(?=(\w| ){3})/g, '*')
		},
		{
			title: 'Cliente',
			dataIndex: 'customer',
			render: t => t.name.toUpperCase()
		},
		{
			title: 'Cédula',
			dataIndex: 'customer',
			render: t => t.document
		},
		// {
		// 	title: 'Valor Total',
		// 	width: '120px',
		// 	dataIndex: 'products',
		// 	render: t => {
		// 		let total = 0
		// 		t.map(p => total = total + parseInt(p.pivot.value))
		// 		return `$ ${currency(total)}`
		// 	}
		// },
		{
			title: 'Facturas Cliente',
			dataIndex: 'customer',
			render: t => `${t.invoices.length} facturas`
		},
		{
			title: 'Llamadas Registradas',
			dataIndex: 'customer',
			render: t => `${t.call_logs.length} llamadas`
		},
		{
			title: 'Clics Btn WA',
			dataIndex: 'click_logs_count',
			render: t => `${t} clics`
		},
		{
			title: 'Recompras Registradas',
			dataIndex: 'customer',
			render: t => `${t.sale_logs.length} recompras`
		},
		{
			title: 'Acciones',
			width: '210px',
			render: (t,r) => (
				<React.Fragment>
					<CallButton
						customer={r.customer}
						invoiceId={r.id}
						customerId={r.customer_id}
						reload={reload}
						disabled={!r.customer.is_callable}
					/>
					<WhatsappButton
						customer={r.customer}
						invoiceId={r.id}
						reload={reload}
						disabled={!r.customer.is_callable}
					/>
					<Tooltip title="Registrar Venta">
						<Button 
							size='sm' 
							color="primary" 
							outline 
							className='px-2' 
							onClick={() => setNewSaleLog(r)}
						>
							<FontAwesomeIcon icon={faDollarSign} />
						</Button>
					</Tooltip>
					<Divider type='vertical' />
					<Tooltip title="Ver Facturas">
						<Button 
							size='sm' 
							color="primary" 
							outline 
							className='px-2' 
							onClick={() => setInvoicesDrawer(r.customer.id)}
						>
							<FontAwesomeIcon icon={faFileInvoiceDollar} />
						</Button>
					</Tooltip>
				</React.Fragment>
			)
		}
	]

	const expandedRowRender = r => (
		<React.Fragment>
			{ r.products.map(product => (
				<p key={product.id} className='mb-2'>
					{product.description} ({product.pivot.quantity} UND)
				</p>
			)) }
		</React.Fragment>
	)
	
	return (
		<React.Fragment>
			<Table 
				dataSource={invoices}
				columns={columns}
				rowKey={r => r.reference}
				loading={!invoices}
				expandable={{ expandedRowRender }}
				pagination={false}
				size="small"
			/>
			<Pagination 
				reload={reload}
				pagination={pagination}
				updatePagination={setPagination}		
			/>
			{ invoicesDrawer && (
				<CustomerInvoicesDrawer 
					visible
					onClose={() => setInvoicesDrawer(null)}
					customerId={invoicesDrawer}
				/>
			)}
			{ newSaleLog && (
				<NewSaleLogModal 
					visible
					onClose={() => setNewSaleLog(null)}
					customer={newSaleLog.customer}
					prevInvoice={newSaleLog}
					reload={reload}
				/>
			)}
		</React.Fragment>
	)
}